import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// 대표님이 캡처하신 바로 그 설정값입니다!
// (참고: 이 설정값은 공개되어도 안전한 값입니다. 실제 보안은 Firebase 인증 + Firestore 규칙이 담당합니다.)
export const firebaseConfig = {
  apiKey: "AIzaSyDoamv_tp9MNkLDha82MX1Dc2ID-nM4BhE",
  authDomain: "e2b-crm.firebaseapp.com",
  projectId: "e2b-crm",
  storageBucket: "e2b-crm.firebasestorage.app",
  messagingSenderId: "330318203758",
  appId: "1:330318203758:web:04f6c037e7fe568f5a8f7f",
  measurementId: "G-SJTJRKHT1W"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app); // 데이터 저장용
export const auth = getAuth(app);    // 로그인용
export const storage = getStorage(app); // 사진 등 파일 보관용(문서에 직접 넣으면 1MB 한도를 넘김)